import { ConfigService } from "../../assets/lib/kookit-extra-browser.min";
import { isElectron } from "react-device-detect";
import { getIframeDoc, getIframeWin } from "./docUtil";
import { handleExitFullScreen, handleFullScreen, sleep } from "../common";
import Hammer from "hammerjs";
import TTSUtil from "./ttsUtil";
declare var window: any;

let throttleTime =
  ConfigService.getReaderConfig("isSliding") === "yes" ? 1000 : 100;

export const getSelection = (format: string, bookKey?: string) => {
  let docs = getIframeDoc(format, bookKey);
  let text = "";
  for (let i = 0; i < docs.length; i++) {
    let doc = docs[i];
    if (!doc) continue;
    let sel = doc.getSelection();
    if (!sel) continue;
    text = sel.toString();
    text = text && text.trim();
    if (text) {
      break;
    }
  }

  return text;
};

export const getSelectionSentence = (
  format: string,
  bookKey?: string
): string => {
  let docs = getIframeDoc(format, bookKey);
  for (let i = 0; i < docs.length; i++) {
    let doc = docs[i];
    if (!doc) continue;
    let sel = doc.getSelection();
    if (!sel || !sel.toString().trim()) continue;
    try {
      let range = sel.getRangeAt(0);
      let container = range.commonAncestorContainer;
      // Walk up to a text-containing element
      let el: Node | null =
        container.nodeType === Node.TEXT_NODE
          ? container.parentElement
          : container;
      let fullText = (el as Element)?.textContent || "";
      let selectedText = sel.toString().trim();
      // Split on sentence-ending punctuation to find the sentence
      let sentences = fullText.split(/(?<=[.!?。！？])\s*/);
      for (let s of sentences) {
        if (s.includes(selectedText)) {
          return s.trim();
        }
      }
      // Fallback: return the whole text content of the container
      return fullText.trim();
    } catch {
      // ignore
    }
  }
  return "";
};
export const searchInTheBook = (
  keyword: string,
  format: string,
  isSearch: boolean
) => {
  let leftPanel = document.querySelector(".left-panel");
  const clickEvent = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: true,
  });
  if (!leftPanel) return;
  leftPanel.dispatchEvent(clickEvent);
  const focusEvent = new MouseEvent("focus", {
    view: window,
    bubbles: true,
    cancelable: true,
  });
  let searchBox: any = document.querySelector(".header-search-box");
  searchBox.dispatchEvent(focusEvent);
  let searchIcon = document.querySelector(".header-search-icon");
  searchIcon?.dispatchEvent(clickEvent);
  if (isSearch) {
    searchBox.value = getSelection(format) || keyword;
  }
  const keyEvent: any = new KeyboardEvent("keydown", {
    bubbles: true,
    cancelable: true,
    keyCode: 13,
  } as any);
  searchBox.dispatchEvent(keyEvent);
};
export const openTableOfContents = () => {
  let leftPanel = document.querySelector(".left-panel");
  const clickEvent = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: true,
  });
  if (!leftPanel) return;
  leftPanel.dispatchEvent(clickEvent);
};
let lock = false; //prevent from clicking too fasts
const arrowKeys = async (
  rendition: any,
  keyCode: number,
  event: any,
  readerMode: string
) => {
  if (
    event.target.tagName.toLowerCase() === "textarea" ||
    event.target.tagName.toLowerCase() === "input"
  ) {
    return;
  }
  if (readerMode === "scroll" && (keyCode === 38 || keyCode === 40)) {
  } else if (keyCode === 33 || keyCode === 37 || keyCode === 38) {
    event.preventDefault();
    await rendition.prev();
  } else if (
    keyCode === 32 ||
    keyCode === 34 ||
    keyCode === 39 ||
    keyCode === 40
  ) {
    event.preventDefault();
    await rendition.next();
  }
  handleShortcut(event);
};

const mouseChrome = async (rendition: any, deltaY: number) => {
  if (deltaY < 0) {
    await rendition.prev();
  }
  if (deltaY > 0) {
    await rendition.next();
  }
};

const handleShortcut = (event: any) => {
  if (event.keyCode === 9) {
    if (isElectron) {
      event.preventDefault();
      window.require("electron").ipcRenderer.invoke("hide-reader", "ping");
    }
  }
  if (event.keyCode === 27) {
    if (ConfigService.getReaderConfig("isFullscreen") === "yes") {
      ConfigService.setReaderConfig("isFullscreen", "no");
      handleExitFullScreen();
    } else {
      ConfigService.setReaderConfig("isFullscreen", "no");
      window.speechSynthesis && window.speechSynthesis.cancel();
      TTSUtil.pauseAudio();
      if (isElectron) {
        if (ConfigService.getReaderConfig("isOpenInMain") === "yes") {
          window.require("electron").ipcRenderer.invoke("exit-tab", "ping");
        } else {
          window.close();
        }
      } else {
        ConfigService.setReaderConfig("isFinishWebReading", "yes");
        window.close();
      }
    }
  }
  if (event.keyCode === 122) {
    event.preventDefault();
    const entering =
      ConfigService.getReaderConfig("isFullscreen") !== "yes";
    entering ? handleFullScreen() : handleExitFullScreen();
    ConfigService.setReaderConfig("isFullscreen", entering ? "yes" : "no");
  }
  if (event.keyCode === 123) {
    if (isElectron && ConfigService.getReaderConfig("isMergeWord")) {
      event.preventDefault();
      ConfigService.setReaderConfig(
        "isMergeWord",
        ConfigService.getReaderConfig("isMergeWord") === "yes" ? "no" : "yes"
      );
      window.require("electron").ipcRenderer.invoke("switch-moyu", "ping");
    }
  }
  if (event.keyCode === 70 && event.ctrlKey) {
    event.preventDefault();
    searchInTheBook("", "", false);
  }
  if (event.keyCode === 66 && event.ctrlKey) {
    event.preventDefault();
    openTableOfContents();
  }
};

const gesture = async (rendition: any, type: string) => {
  if (type === "panleft" || type === "panup") {
    await rendition.next();
  }
  if (type === "panright" || type === "pandown") {
    await rendition.prev();
  }
};

const handleLocation = (key: string, rendition: any) => {
  let position = rendition.getPosition();
  ConfigService.setObjectConfig(key, position, "recordLocation");
};
export const scrollChapter = async (
  element: any,
  rendition: any,
  deltaY: number
) => {
  if (deltaY < 0) {
    if (element.scrollTop === 0) {
      await rendition.prev();
    }
  }
  if (deltaY > 0) {
    var scrollHeight = element.scrollHeight;
    var scrollTop = element.scrollTop;
    var clientHeight = element.clientHeight;
    if (Math.abs(scrollTop + clientHeight - scrollHeight) < 10) {
      await rendition.next();
    }
  }
};
let lastScaleTime = 0;
export const bindHtmlEvent = (
  rendition: any,
  doc: any,
  key: string = "",
  readerMode: string = "",
  handleScale: (scale: string) => void,
  renderBookFunc: () => void
) => {
  doc.addEventListener(
    "keydown",
    async (event) => {
      if (lock) return;
      lock = true;
      await arrowKeys(rendition, event.keyCode, event, readerMode);
      handleLocation(key, rendition);
      setTimeout(() => (lock = false), throttleTime);
    },
    { passive: false }
  );

  doc.addEventListener(
    "wheel",
    async (event) => {
      if (event.ctrlKey && readerMode !== "double") {
        const currentTime = Date.now();
        if (currentTime - lastScaleTime < 1500) {
          return;
        }
        lastScaleTime = currentTime;
        event.preventDefault();
        let scale = parseFloat(ConfigService.getReaderConfig("scale") || "1");
        if (event.deltaY < 0) {
          ConfigService.setReaderConfig("scale", scale + 0.1 + "");
        } else {
          ConfigService.setReaderConfig("scale", scale - 0.1 + "");
        }
        handleScale(ConfigService.getReaderConfig("scale") || "1");
        renderBookFunc();
        return;
      }
      if (lock) return;
      lock = true;

      // ── 对照模式：阻尼滚动（去除 mouseChrome 的额外跳转） ──
      if (readerMode === "contrast" && Math.abs(event.deltaX) === 0) {
        event.preventDefault();
        const container = document.getElementById("page-area");
        if (container) {
          const MAX_STEP = 25; // 每次滚轮事件最多 25px
          const delta =
            Math.sign(event.deltaY) * Math.min(Math.abs(event.deltaY), MAX_STEP);
          container.scrollTop += delta;
        }
        await sleep(200);
        await rendition.record();
        const el = document.getElementById("page-area");
        if (el) {
          await scrollChapter(el, rendition, event.deltaY);
        }
        handleLocation(key, rendition);
        setTimeout(() => (lock = false), throttleTime);
        return;
      }

      if (readerMode === "scroll") {
        await sleep(200);
        await rendition.record();
        if (
          Math.abs(event.deltaX) === 0 &&
          ConfigService.getReaderConfig("isDisableAutoScroll") !== "yes"
        ) {
          let srollElement = document.getElementById("page-area");
          await scrollChapter(srollElement, rendition, event.deltaY);
        }
      } else {
        if (Math.abs(event.deltaX) === 0) {
          await mouseChrome(rendition, event.deltaY);
        }
      }
      handleLocation(key, rendition);
      setTimeout(() => (lock = false), throttleTime);
    },
    { passive: false }
  );

  window.addEventListener(
    "keydown",
    async (event) => {
      if (lock) return;
      lock = true;
      await arrowKeys(rendition, event.keyCode, event, readerMode);
      handleLocation(key, rendition);
      setTimeout(() => (lock = false), throttleTime);
    },
    { passive: false }
  );

  if (ConfigService.getReaderConfig("isTouch") === "yes") {
    const mc = new Hammer(doc);
    mc.on("panleft panright panup pandown", async (event: any) => {
      if (readerMode === "scroll") {
        return;
      }
      if (lock || event.pointerType === "mouse") return;
      lock = true;
      await gesture(rendition, event.type);
      handleLocation(key, rendition);
      setTimeout(() => (lock = false), throttleTime);
    });
  }

  doc.addEventListener(
    "touchend",
    async () => {
      if (lock) return;
      lock = true;
      if (readerMode === "scroll") {
        await sleep(200);
        await rendition.record();
      }
      handleLocation(key, rendition);
      setTimeout(() => (lock = false), throttleTime);
    },
    { passive: false }
  );
};
export const htmlMouseEvent = (
  rendition: any,
  key: string,
  readerMode: string,
  format: string,
  handleScale: (scale: string) => void,
  renderBookFunc: () => void
) => {
  rendition.on("rendered", () => {
    let iframe = getIframeWin();
    if (!iframe) return;
    iframe?.focus();
    let docs = getIframeDoc(format, key);
    for (let i = 0; i < docs.length; i++) {
      let doc = docs[i];
      if (!doc) continue;
      bindHtmlEvent(
        rendition,
        doc,
        key,
        readerMode,
        handleScale,
        renderBookFunc
      );
    }
    lock = false;
    // 兜底：rendered 事件触发时也绑定拖拽滚动（处理 re-render 场景）
    if (readerMode === "contrast" || ConfigService.getReaderConfig("readerMode") === "contrast") {
      bindDragScroll(format, key);
    }
  });
};

// ── 对照模式：长按拖拽滚动 ──────────────────────────────────────

const LONG_PRESS_MS = 300;
const DRAG_THRESHOLD = 3; // px，超过此移动量视为拖拽
const MAX_RETRIES = 10;

let _dragScrollBound = false; // 防止重复绑定 window 监听器
let _dragBindRetries = 0;    // 重试计数

export const bindDragScroll = (format: string, bookKey?: string) => {
  const container = document.getElementById("page-area");
  if (!container) return;

  // 获取 iframe document
  const docs = getIframeDoc(format, bookKey);
  if (!docs.length) {
    _dragBindRetries++;
    if (_dragBindRetries <= MAX_RETRIES) {
      requestAnimationFrame(() => bindDragScroll(format, bookKey));
    } else {
      // rAF 重试耗尽，改用 MutationObserver 等待 iframe 创建
      _dragBindRetries = 0;
      const observer = new MutationObserver(() => {
        const retryDocs = getIframeDoc(format, bookKey);
        if (retryDocs.length) {
          observer.disconnect();
          _setupDragScroll(container, retryDocs);
        }
      });
      observer.observe(container, { childList: true, subtree: true });
    }
    return;
  }

  _dragBindRetries = 0;
  _setupDragScroll(container, docs);
};

function _setupDragScroll(container: HTMLElement, docs: (Document | null)[]) {
  let isDragMode = false;
  let longPressTimer: any = null;
  let startX = 0;
  let startY = 0;
  let startScrollTop = 0;
  let hasMoved = false;

  const clearTimer = () => {
    if (longPressTimer) {
      clearTimeout(longPressTimer);
      longPressTimer = null;
    }
  };

  const enterDragMode = () => {
    isDragMode = true;
    container.style.cursor = "grabbing";
    for (const d of docs) {
      if (d) d.body.style.cursor = "grabbing";
    }
    // 清除长按时可能产生的文本选中
    try {
      for (const d of docs) {
        if (d) d.getSelection()?.removeAllRanges();
      }
    } catch {}
  };

  const exitDragMode = () => {
    isDragMode = false;
    clearTimer();
    container.style.cursor = "";
    for (const d of docs) {
      if (d) d.body.style.cursor = "";
    }
  };

  const onMouseDown = (e: MouseEvent) => {
    if (e.button !== 0) return;
    startX = e.clientX;
    startY = e.clientY;
    startScrollTop = container.scrollTop;
    hasMoved = false;

    clearTimer();
    longPressTimer = setTimeout(() => {
      longPressTimer = null;
      enterDragMode();
    }, LONG_PRESS_MS);
  };

  const onMouseMove = (e: MouseEvent) => {
    if (isDragMode) {
      const deltaY = startY - e.clientY;
      if (Math.abs(deltaY) > DRAG_THRESHOLD) {
        hasMoved = true;
      }
      container.scrollTop = startScrollTop + deltaY;
      return;
    }

    // 长按等待期间，如果有移动则取消（让用户正常选文本）
    if (longPressTimer) {
      if (
        Math.abs(e.clientX - startX) > DRAG_THRESHOLD ||
        Math.abs(e.clientY - startY) > DRAG_THRESHOLD
      ) {
        clearTimer();
      }
    }
  };

  const onMouseUp = () => {
    if (isDragMode && hasMoved) {
      // 拖拽后阻止穿透的 click 事件
      window.addEventListener(
        "click",
        (ev) => {
          ev.stopPropagation();
          ev.preventDefault();
        },
        { capture: true, once: true }
      );
    }
    clearTimer();
    exitDragMode();
  };

  for (const doc of docs) {
    if (!doc) continue;
    doc.addEventListener("mousedown", onMouseDown);
    // mousemove / mouseup 必须绑在 iframe document 上：
    // 鼠标在 iframe 内按下后，后续事件锁在 iframe 内，不会冒泡到父 window
    doc.addEventListener("mousemove", onMouseMove);
    doc.addEventListener("mouseup", onMouseUp);
  }

  // window 监听器作为补充（鼠标拖出 iframe 后仍能跟踪，只绑一次）
  if (!_dragScrollBound) {
    _dragScrollBound = true;
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
  }
}
